import api from "./api";

export const uploadsService = {
    async upload(file) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/uploads", fd, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return data; // { filename, url, size, mime }
    },
};
